import api from '@/api'

export default {
  fetchAsyncResults(resultId) {
    return api.get(`/async_results/${resultId}`)
  }
}
